import React from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-16 md:py-24 bg-blue-900 text-white" data-id="element-118">
      <div className="container mx-auto px-4" data-id="element-119">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-121">
            Let's Work Together
          </h2>
          <p className="text-xl text-blue-100" data-id="element-122">
            Ready to transform your ideas into impactful strategies? Get in
            touch with our team today.
          </p>
        </div>
        <div className="grid md:grid-cols-5 gap-8 max-w-5xl mx-auto" data-id="element-123">
          <div className="md:col-span-2 space-y-8" data-id="element-124">
            <div data-id="element-125">
              <h3 className="text-2xl font-bold mb-6" data-id="element-126">Contact Information</h3>
              <div className="space-y-4" data-id="element-127">
                <div className="flex items-start" data-id="element-128">
                  <Mail className="mr-4 text-amber-400" size={20} data-id="element-129" />
                  <div data-id="element-130">
                    <p className="font-medium" data-id="element-131">Email Us</p>
                    <p className="text-blue-200" data-id="element-132">contact@lifefort.ng</p>
                    <p className="text-blue-200" data-id="element-133">consultlifefort@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-134">
                  <Phone className="mr-4 text-amber-400" size={20} data-id="element-135" />
                  <div data-id="element-136">
                    <p className="font-medium" data-id="element-137">Call Us</p>
                    <p className="text-blue-200" data-id="element-138">+2347084189531</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-139">
                  <MapPin className="mr-4 text-amber-400" size={20} data-id="element-140" />
                  <div data-id="element-141">
                    <p className="font-medium" data-id="element-142">Location</p>
                    <p className="text-blue-200" data-id="element-143">Africa & Diaspora</p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-144">
              <h3 className="text-xl font-bold mb-4" data-id="element-145">We serve clients in:</h3>
              <div className="grid grid-cols-2 gap-2" data-id="element-146">
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-147">
                  Nigeria
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-148">
                  Ghana
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-149">
                  Kenya
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-150">
                  South Africa
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-151">UK</div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-152">
                  USA
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-153">
                  Canada
                </div>
                <div className="bg-blue-800/50 rounded p-2 text-center" data-id="element-154">
                  & More
                </div>
              </div>
            </div>
          </div>
          <div className="md:col-span-3 bg-white text-gray-900 p-8 rounded-lg shadow-lg" data-id="element-155">
            <h3 className="text-2xl font-bold mb-6" data-id="element-156">Send us a message</h3>
            <form data-id="element-157">
              <div className="grid md:grid-cols-2 gap-4 mb-4" data-id="element-158">
                <div data-id="element-159">
                  <label htmlFor="name" className="block text-gray-700 mb-1 font-medium" data-id="element-160">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <label htmlFor="email" className="block text-gray-700 mb-1 font-medium" data-id="element-163">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-164" />
                </div>
              </div>
              <div className="mb-4" data-id="element-165">
                <label htmlFor="organization" className="block text-gray-700 mb-1 font-medium" data-id="element-166">
                  Organization/Project
                </label>
                <input type="text" id="organization" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-167" />
              </div>
              <div className="mb-4" data-id="element-168">
                <label htmlFor="service" className="block text-gray-700 mb-1 font-medium" data-id="element-169">
                  Service Interest
                </label>
                <select id="service" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-170">
                  <option value="" data-id="element-171">Select a service</option>
                  <option value="ideas" data-id="element-172">IDEAS</option>
                  <option value="strategy" data-id="element-173">STRATEGY</option>
                  <option value="execution" data-id="element-174">EXECUTION</option>
                  <option value="multiple" data-id="element-175">Multiple Services</option>
                  <option value="not-sure" data-id="element-176">Not Sure Yet</option>
                </select>
              </div>
              <div className="mb-6" data-id="element-177">
                <label htmlFor="message" className="block text-gray-700 mb-1 font-medium" data-id="element-178">
                  Your Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-179"></textarea>
              </div>
              <button type="submit" className="bg-blue-800 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition flex items-center justify-center" data-id="element-180">
                Send Message
                <Send size={18} className="ml-2" data-id="element-181" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};